const submittedStatuses = new Set([
  'submitted',
  'review_approved',
  'review_rejected',
]);

export const getServiceTaskStage = (task = {}, now = Date.now()) => {
  if (task.serviceStatus === 'handled' || task.status === 'handled') return 'handled';
  if (task.status === 'needs_fix') return 'pending';
  if (
    submittedStatuses.has(task.status) ||
    Boolean(task.submittedAt) ||
    (task.responses && Object.keys(task.responses).length > 0)
  ) {
    return 'submitted';
  }
  const deadline = task.serviceDeadline || task.exchangeDeadline;
  const deadlineMs = deadline ? new Date(deadline).getTime() : 0;
  if (deadlineMs && Number.isFinite(deadlineMs) && deadlineMs < now) return 'expired';
  return 'pending';
};

export const isPendingServiceTask = (task = {}, now = Date.now()) => (
  getServiceTaskStage(task, now) === 'pending'
);

export const isSubmittedServiceTask = (task = {}, now = Date.now()) => (
  ['submitted', 'handled'].includes(getServiceTaskStage(task, now))
);
